import React from 'react';

/**
 * "Possible scam" (C29-1 AC10): text plus a danger outline, never colour alone. Shown for
 * an item that is held, high with no verdict yet, or that the person called a scam.
 */
const ScamMark: React.FC<{ 'data-testid': string; count?: number }> = ({ 'data-testid': testId, count }) => (
    <span
        data-testid={testId}
        className="inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-danger"
        style={{
            border: '1px solid var(--color-danger)',
            background: 'rgba(var(--color-danger-rgb), 0.08)',
        }}
    >
        Possible scam{count && count > 1 ? ` · ${count}` : ''}
    </span>
);

export default ScamMark;
